import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Dropdown, Menu } from 'semantic-ui-react';
import { isCurrentUserStaffOrSuperAdmin, isCurrentUserSuperUser } from '../selectors/auth';

interface NavigationItem {
  name: string;
  path: string;
  requiresSuperUser?: boolean;
  requiresStaff?: boolean;
  external?: boolean;
}

const navigationItems: NavigationItem[] = [
  { name: 'Settings', path: '/settings/admin', requiresStaff: true },
  { name: 'Portal', path: '/app/dashboard' },
  { name: 'Survey', path: process.env.REACT_APP_SURVEY_URL || '', external: true },
  { name: 'Monitoring', path: '/monitoring', requiresSuperUser: true },
  {
    name: 'API Documentation',
    path: 'http://localhost:8000/docs/',
    external: true,
    requiresSuperUser: true,
  },
];

const NavigationMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isUserSuperUser = useSelector(isCurrentUserSuperUser);
  const isUserStaff = useSelector(isCurrentUserStaffOrSuperAdmin);

  const filteredItems = navigationItems.filter(item => {
    if (item.requiresSuperUser && !isUserSuperUser) return false;
    if (item.requiresStaff && !isUserStaff && !isUserSuperUser) return false;
    return true;
  });

  const handleItemClick = (item: NavigationItem) => {
    if (item.external) {
      window.open(item.path, '_blank');
    } else {
      navigate(item.path);
    }
  };

  return (
    <Menu.Item position="left">
      <Dropdown
        trigger={
          <Button
            icon="bars"
            content="NuLogic"
            style={{ backgroundColor: '#1B1C1D', color: 'white' }}
          />
        }
        pointing="top left"
        className="link item"
      >
        <Dropdown.Menu>
          {filteredItems.map(item => (
            <Dropdown.Item
              key={item.path}
              active={!item.external && location.pathname.startsWith(item.path)}
              onClick={() => handleItemClick(item)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </Menu.Item>
  );
};

export default NavigationMenu;
